import { useT } from '../i18n'

export default function LangSwitch({ className = '' }: { className?: string }) {
  const { locale, setLocale, t } = useT()
  return (
    <button
      type="button"
      onClick={() => setLocale(locale === 'en' ? 'ar' : 'en')}
      className={`text-xs text-stone-500 hover:text-stone-900 underline ${className}`}
      aria-label="Switch language"
    >
      {t('lang.toggle')}
    </button>
  )
}
